import { ContentCard } from "@msuite/ui/content-card";
import { icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { Tag } from "@msuite/ui/tag";
import { guardString } from "@msuite/utils/strings";
import { useMailbox } from "@/hooks/use-mailbox";

/** Props Interface */
interface MailboxHeaderProps {
	mailboxId: string;
}

export function MailboxHeader({ mailboxId }: MailboxHeaderProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Query */
	const { mailbox } = useMailbox(mailboxId);

	/** Render */
	return (
		<ContentCard
			title={mailbox ? mailbox.label : t("mailboxes.mailbox")}
			icon={icon("Mail")}
			// The label is what tells one mailbox from the next in the breadcrumb, not the uuid.
			identifier={mailbox ? mailboxId : undefined}
			dataPageBreadcrumbsTitle={mailbox?.label}
			accessory={
				<Tag
					color="emerald"
					variant="plain"
				>
					{t("mailboxes.connected")}
				</Tag>
			}
		>
			<div className="h-stack">
				<span>{guardString(mailbox?.emailAddress)}</span>
			</div>
		</ContentCard>
	);
}
